module.exports = __webpack_public_path__ + "static/media/10-RotHeatExchanger - DX cool - El heat.2cc1143f.png";